import { useMutation as useBusinessAddress } from "@faire/web-api/api/retailer/find-business-address/post-hooks";
import { QueryParameters } from "@faire/web-api/api/retailer/find-businesses/get";
import { useQuery as useFindBusinessesQuery } from "@faire/web-api/api/retailer/find-businesses/get-hooks";
import { debounceIfPossible } from "@faire/web/common/globals/debounceIfPossible";
import { useEffect, useState } from "react";

import { IAddressOption } from "@faire/retailer/components/GoogleMapsComponent/CustomAddressDropdown";

export const useAutoComplete = (query: string, country: string) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [queryBusinesses, setQueryBusinesses] = useState(false);
  const [autoCompleteResults, setAutoCompleteResults] = useState<
    IAddressOption[]
  >([]);

  const {
    data: businesses,
    isPending: isLoading,
    isFetching,
  } = useFindBusinessesQuery(
    QueryParameters.build({
      query,
      country,
    }),
    {
      enabled: queryBusinesses,
    }
  );

  const { mutate: getBusinessAddress } = useBusinessAddress();

  const debouncedSearch = debounceIfPossible(
    (enable: boolean) => setQueryBusinesses(enable),
    250
  );

  useEffect(() => {
    if (query.length > 2) {
      debouncedSearch(true);
    } else {
      debouncedSearch(false);
    }
  }, [query, country, debouncedSearch]);

  useEffect(() => {
    if (businesses) {
      setAutoCompleteResults(
        businesses.map((business) => ({
          ...business,
          id: business.id ?? "",
        }))
      );
    } else {
      setAutoCompleteResults([]);
    }
  }, [businesses]);

  return {
    isDropdownOpen,
    setIsDropdownOpen,
    autoCompleteResults,
    getBusinessAddress,
    areBusinessesLoading: isLoading && isFetching,
  };
};
